import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/connect-hmd",
)({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/connect-device",
      search,
    });
  },
});
